import { allSystemProps } from 'shared/styles/props';
import { theme } from 'shared/styles/theme';
import { Typography } from 'shared/ui/Typography';

import styled from '@emotion/styled';

export const HiddenCheckbox = styled.input({
  opacity: 0,
  height: 0,
  width: 0,
});

export const StyledCheckbox = styled.div<{ checked: boolean; disabled?: boolean }>(({ checked, disabled }) => ({
  display: 'inline-block',
  borderRadius: 8,
  minWidth: 18,
  minHeight: 18,
  width: 18,
  height: 18,
  cursor: disabled ? '' : 'pointer',
  padding: 1,
  backgroundColor: checked ? theme.colors.yellow : theme.colors.purewhite,
  border: `2px solid ${disabled ? theme.colors.gray400 : checked ? theme.colors.yellow : theme.colors.black}`,
  transition: '0.1s',

  '& path': {
    stroke: checked ? theme.colors.white : 'transparent',
    opacity: checked ? 1 : 0,
  },

  '&:hover': {
    margin: 0,

    '& path': {
      stroke: theme.colors.black,
    },
  },
}));

export const CheckboxContainer = styled.label(
  {
    display: 'flex',
    alignItems: 'center',
  },
  allSystemProps
);

export const Label = styled(Typography)<{ ml: number }>`
  margin-left: ${({ ml }) => ml}px;
  text-align: left;
`;
